const awsConfig = {
  Auth: {
    Cognito: {
      identityPoolId: process.env.REACT_APP_AWS_IDENTITY,
      userPoolId: process.env.REACT_APP_AWS_POOL_ID,
      userPoolClientId: process.env.REACT_APP_AWS_POOL_CLIENT_ID,
      loginWith: {
        email: true,
      },
    },
  },
};

export default awsConfig;
